import { render } from "./NetworkAlert.vue?vue&type=template&id=379a5fe2&scoped=true"
import script from "./NetworkAlert.vue?vue&type=script&lang=js"
export * from "./NetworkAlert.vue?vue&type=script&lang=js"

import "./NetworkAlert.vue?vue&type=style&index=0&id=379a5fe2&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/bob-web/bob-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379a5fe2"]])

export default __exports__